import { isDev } from "../../../../base/index.js";
import { getByPath } from "../../../../dot-notation/index.js";
import { produce } from "../../../../immer/index.js";
function initializeFields(config) {
  const fieldsStatus = /* @__PURE__ */ new Set();
  const errors = {};
  const initialValues = structuredClone(config.initialValues);
  const fields = config?.fields ? produce(config?.fields, (draft) => {
    for (const key of Object.keys(draft)) {
      const statePath = key;
      let stateValue;
      try {
        stateValue = getByPath(initialValues, statePath);
      } catch (e) {
      }
      const draftKey = key;
      const field = draft[draftKey];
      field.type ??= Array.isArray(stateValue) ? "arrayField" : "field";
      field.value = stateValue;
      field.resetValue ??= stateValue;
      field.visible ??= true;
      field.disabled ??= false;
      field.required ??= false;
      field.validating = false;
      field.status ??= "pristine";
      const errorKey = key;
      const fieldErrors = config.initialErrors?.[errorKey] ?? [];
      if (field.status === "invalid" || fieldErrors.length > 0) {
        if (fieldErrors.length === 0) {
          fieldErrors.push({
            id: `restored-${errorKey}`,
            field: errorKey,
            message: `The field is invalid"`
            // TODO: should support internationalization
          });
        }
        for (const error of fieldErrors) {
          errors[error.id] = error;
        }
        field.status = "invalid";
      }
      fieldsStatus.add(field.status);
    }
  }) : (
    // If `config.fields` is missing set the form to an empty object
    {}
  );
  for (const key of Object.keys(config.initialErrors ?? {})) {
    const fieldName = key;
    if (fields[fieldName]) continue;
    if (isDev()) {
      console.warn(
        `Form field "${fieldName}" does not exist in the form fields configuration, but it has initial errors. This is likely a mistake.`
      );
    }
  }
  const formStatus = (
    // if at least one field is marked invalid, the form status is invalid
    fieldsStatus.has("invalid") ? "invalid" : (
      // if there's only one entry, and it's 'valid' it means all registered fields are `valid` and the form will be too
      fieldsStatus.has("valid") && fieldsStatus.size === 1 ? "valid" : (
        // if at least one field is not `pristine` the form status is `indeterminate`
        fieldsStatus.has("indeterminate") || fieldsStatus.has("valid") ? "indeterminate" : (
          // otherwise it's `pristine`
          "pristine"
        )
      )
    )
  );
  return { initialValues, fields, errors, formStatus };
}
export {
  initializeFields
};
//# sourceMappingURL=createStore.initializeFields.js.map
